// frozen_string_literal: true
import { ReactElement } from 'react';
import { Rating } from '@mantine/core';
import { YotpoReviewsData } from '../../../models/product.types';
import styles from '../ProductDisplayPage.module.scss';

type Props = {
  bottomline: YotpoReviewsData['bottomline'] | undefined;
  hasReviews: boolean;
};

export function RatingsOverview({
  bottomline,
  hasReviews,
}: Props): ReactElement {
  return (
    <div className={styles.ratings_overview}>
      <div className={styles.ratings_overview_row}>
        <span className={styles.ratings_average}>
          {bottomline ? bottomline.average_score.toFixed(1) : '0.0'}
        </span>
        <Rating value={bottomline?.average_score ?? 0} fractions={2} size="lg" readOnly />
      </div>
      {hasReviews ? (
        <span className={styles.ratings_count}>
          out of
          {' '}
          {bottomline?.total_review}
          {' '}
          {bottomline?.total_review === 1 ? 'review' : 'reviews'}
        </span>
      ) : (
        <span className={styles.ratings_count}>Be the first to leave a review!</span>
      )}
    </div>
  );
}
